













































import {Component, Vue} from 'vue-property-decorator';
import { Action } from 'vuex-class';
import ChartCard from '../../components/material/ChartCard.vue';

@Component({
  components: {
    ChartCard,
  },
})
export default class Dashboard extends Vue {
  @Action('admin/users/read') private adminGetUsers: any;
  @Action('moderator/animals/read') private moderatorGetAnimals: any;
  @Action('user/animals/read') private userGetAnimals: any;

  private dailySalesChart: any = {
    data: {
      labels: ['M', 'T', 'W', 'T', 'F', 'S', 'S'],
      series: [
        [12, 17, 7, 17, 23, 18, 38],
      ],
    },
    options: {
      // lineSmooth: this.$chartist.Interpolation.cardinal({
      //   tension: 0,
      // }),
      low: 0,
      high: 50, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
      chartPadding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
      },
    },
  };
  private dataCompletedTasksChart: any = {
    data: {
      labels: ['12am', '3pm', '6pm', '9pm', '12pm', '3am', '6am', '9am'],
      series: [
        [230, 750, 450, 300, 280, 240, 200, 190],
      ],
    },
    options: {
      // lineSmooth: this.$chartist.Interpolation.cardinal({
      //   tension: 0,
      // }),
      low: 0,
      high: 1000, // creative tim: we recommend you to set the high sa the biggest value+something for a better look
      chartPadding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
      },
    },
  };
  private emailsSubscriptionChart: any = {
    data: {
      labels: ['Ja', 'Fe', 'Ma', 'Ap', 'Mai', 'Ju', 'Jul', 'Au', 'Se', 'Oc', 'No', 'De'],
      series: [
        [542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895],

      ],
    },
    options: {
      axisX: {
        showGrid: false,
      },
      low: 0,
      high: 1000,
      chartPadding: {
        top: 0,
        right: 5,
        bottom: 0,
        left: 0,
      },
    },
    responsiveOptions: [
      ['screen and (max-width: 640px)', {
        seriesBarDistance: 5,
        axisX: {
          labelInterpolationFnc(value: any[]) {
            return value[0];
          },
        },
      }],
    ],
  };

  private headers: any[] = [
    {
      sortable: false,
      text: 'ID',
      value: 'id',
    },
    {
      sortable: false,
      text: 'Name',
      value: 'name',
    },
    {
      sortable: false,
      text: 'Salary',
      value: 'salary',
      align: 'right',
    },
    {
      sortable: false,
      text: 'Country',
      value: 'country',
      align: 'right',
    },
    {
      sortable: false,
      text: 'City',
      value: 'city',
      align: 'right',
    },
  ];
  private items: any[] = [
    {
      name: 'Dakota Rice',
      country: 'Niger',
      city: 'Oud-Tunrhout',
      salary: '$35,738',
    },
    {
      name: 'Minerva Hooper',
      country: 'Curaçao',
      city: 'Sinaai-Waas',
      salary: '$23,738',
    }, {
      name: 'Sage Rodriguez',
      country: 'Netherlands',
      city: 'Overland Park',
      salary: '$56,142',
    }, {
      name: 'Philip Chanley',
      country: 'Korea, South',
      city: 'Gloucester',
      salary: '$38,735',
    }, {
      name: 'Doris Greene',
      country: 'Malawi',
      city: 'Feldkirchen in Kārnten',
      salary: '$63,542',
    },
  ];
  private tabs: number = 0;
  private list: boolean[] = [false, false, false];

  private complete(index: number) {
    this.list[index] = !this.list[index];
  }
}
